import { createAsyncThunk } from "@reduxjs/toolkit";
import { createBudgetFromCurrentThunk } from "@/store/budgets/thunks/createBudgetFromCurrentThunk";
import { createBudgetBasedOnFiltersFromCurrentThunk } from "@/store/budgets/thunks/createBudgetBasedOnFiltersFromCurrentThunk";

export const tryCreateBudgetFromCurrentThunk = createAsyncThunk(
  "budgets/tryCreateBudgetFromCurrent",
  async (enableCreateBudgetsBasedOnFiltersFT: boolean, { dispatch }) => {
    if (enableCreateBudgetsBasedOnFiltersFT) {
      return dispatch(createBudgetBasedOnFiltersFromCurrentThunk()).unwrap();
    } else {
      return dispatch(createBudgetFromCurrentThunk()).unwrap();
    }
  },
);
